export const shareTrigger = function() {

    document.querySelectorAll('[data-share-link]').forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent the default link behavior

        const url = event.currentTarget.href;
        const width = 600; // Width of the popup window
        const height = 400; // Height of the popup window
        const left = (window.innerWidth / 2) - (width / 2);
        const top = (window.innerHeight / 2) - (height / 2);

        // Open the popup window
        window.open(
          url,
          '_blank',
          `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
        );
      });
    });

}



// WEBPACK FOOTER //
// ./scripts/functions/social-share.js